import './App.css';
import Home from './page/Home';


function App() {
  return (
    <div>
   <Home />
    </div>
  );
}

export default App;
